import styled, { css } from 'styled-components';
import { colors } from '@dexma/ui-components';

export const AI_DESCRIPTION_LINE_HEIGHT = 20;
export const AI_DESCRIPTION_GAP = 8;

export const Description = styled.p<{ $maxLines?: number }>`
    margin: 0;
    font-size: 14px;
    line-height: ${AI_DESCRIPTION_LINE_HEIGHT}px;
    letter-spacing: -0.24px;
    text-align: center;
    color: ${colors.black};
    ${({ $maxLines }) =>
        $maxLines &&
        css`
            display: -webkit-box;
            -webkit-line-clamp: ${$maxLines};
            -webkit-box-orient: vertical;
            overflow: hidden;
        `}
`;

export const Loading = styled(Description)`
    color: ${colors.gray700};
    font-style: italic;
`;

export const Disclaimer = styled.p`
    margin: 0;
    font-size: 10px;
    line-height: 14px;
    text-align: center;
    color: ${colors.gray600};
`;

export const AiDescriptionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${AI_DESCRIPTION_GAP}px;
`;
